import moment from "moment-timezone";

const JERUSALEM_TIMEZONE = "Asia/Jerusalem";

moment.tz.setDefault(JERUSALEM_TIMEZONE);

export const getUserTimezone = (): string => {
  return JERUSALEM_TIMEZONE;
};

export const formatDateForDisplay = (date: string | Date, format: string = "MM/DD/YYYY"): string => {
  return moment.tz(date, JERUSALEM_TIMEZONE).format(format);
};

export const formatDateForGrouping = (date: string | Date): string => {
  return moment.tz(date, JERUSALEM_TIMEZONE).format("MM/DD/YYYY");
};

export const parseDate = (date: string | Date) => {
  return moment.tz(date, JERUSALEM_TIMEZONE);
};

export const getTodayFormatted = (format: string = "MM/DD/YYYY"): string => {
  return moment.tz(JERUSALEM_TIMEZONE).format(format);
};

export const compareDates = (date1: string | Date, date2: string | Date): number => {
  const d1 = moment.tz(date1, JERUSALEM_TIMEZONE);
  const d2 = moment.tz(date2, JERUSALEM_TIMEZONE);
  return d1.diff(d2);
};

export const compareTimes = (time1: string, time2: string): number => {
  const t1 = moment(time1, ["h:mm A", "HH:mm"]);
  const t2 = moment(time2, ["h:mm A", "HH:mm"]);
  return t1.diff(t2);
};

export const findClosestDate = (dateArray: string[], targetDate?: string | Date): string | null => {
  const target = targetDate ? moment.tz(targetDate, JERUSALEM_TIMEZONE) : moment.tz(JERUSALEM_TIMEZONE);
  let closestDate = null;
  let closestDiff = Infinity;

  dateArray.forEach((dateStr) => {
    const date = moment.tz(dateStr, "MM/DD/YYYY", JERUSALEM_TIMEZONE);
    const diff = Math.abs(date.diff(target, "days"));
    if (diff < closestDiff) {
      closestDiff = diff;
      closestDate = dateStr;
    }
  });

  return closestDate;
}; 